module.exports = __webpack_public_path__ + "media/images/front/bg_doctor_header-5bab73df746482a8f5767c982bb3f5c4.jpg";